export const DATA_QA_ONLINE_ONLY = 'online-order-only';
export const DATA_QA_PRODUCT = 'product';
export const DATA_QA_PRODUCT_NAME = 'product-name';
export const DATA_QA_PRODUCT_REVIEWS = 'product-reviews';
